<template>
	<div class="offer-bidder-name" v-if="bidderName">
		<v-layout row>
			<v-flex xs12 md12>
				<v-card style="margin: 10px">
					<v-card-title>
						<h3>Nazwa oferenta</h3>
					</v-card-title>
					<v-card-text>
						<h4>{{ bidderName }}</h4>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
	import {Bidder} from "@/api/generated/Bidder";

	export default {
		name: "BidderNameReadOnlyView",

		data () {
			return {
				bidderName: '',
        bidderId: null,
        offerId: this.$route.params.offerId,
        projectId: this.$route.params.projectId,
			};
		},

    methods: {
      getBidderDetails() {
        if (this.offerId) {
          this.getBidderDetailsByOfferId();
        } else if (this.projectId) {
          this.getBidderDetailsByProjectId();
        }
      },

      bidderDetailsRequestSuccessHandler() {
        return (successResponse) => {
          this.bidderName = successResponse.polishName;
        };
      },

      bidderDetailsRequestErrorHandler() {
        return (errorResponse) => {
          this.$messagesBus.$emit("error", "Nie udało się załadować danych oferenta", errorResponse);
        };
      },

      getBidderDetailsByOfferId() {
        if (this.$route.params.version) {
          Bidder.getOriginalOfferVersionDetails(this, this.bidderId, this.offerId, this.$route.params.version,
              this.bidderDetailsRequestSuccessHandler(), this.bidderDetailsRequestErrorHandler());
        } else {
          Bidder.getOriginalOfferDetails(this, this.bidderId, this.offerId,
              this.bidderDetailsRequestSuccessHandler(), this.bidderDetailsRequestErrorHandler());
        }
      },

      getBidderDetailsByProjectId() {
        if (this.$route.params.version) {
          Bidder.getOriginalProjectVersionDetails(this, this.bidderId, this.projectId, this.$route.params.version,
              this.bidderDetailsRequestSuccessHandler(), this.bidderDetailsRequestErrorHandler());
        } else {
          Bidder.getOriginalProjectDetails(this, this.bidderId, this.projectId,
              this.bidderDetailsRequestSuccessHandler(), this.bidderDetailsRequestErrorHandler());
        }
      }
    },

		watch: {
			viewData: {
				immediate: true,
				handler (val) {
					if (val.mainBidderId) {
            this.bidderId = val.mainBidderId;
            this.getBidderDetails();
          }
				}
			},
		},

		props: {
			viewData: {}
		},
	};
</script>

<style scoped>
	.offer-bidder-name {
		margin-bottom: 10px;
	}
</style>